// The editable shape of platformConfig/playerPackTemplates for the Player
// Packs page (routes/PlayerPacks.tsx). Validated server-side by v4's own
// validator (teamstore-createproducts-v4/lib/player-pack-templates.js).

export type SlotId = 'tee' | 'shorts' | 'hoodie' | 'backpack';
export type SlotTemplate = {
  sourceStyle: string;
  logoLocation: 'FC' | 'LL';
  includedPersonalization?: 'back';
  extraSpots?: string[];
};
export type Pack = { id: string; label: string; slots: SlotId[] };
// 'school' = primary, then secondary, then black; 'black' = every pack garment
// is black on every store (Grant 2026-10-08). Absent in the doc = 'school'.
export type GarmentColor = 'school' | 'black';
export type Templates = {
  version: 1;
  enabled: boolean;
  garmentColor: GarmentColor;
  slots: Partial<Record<SlotId, SlotTemplate>>;
  packs: Pack[];
};
export type StoredTemplates = Omit<Templates, 'garmentColor'> & {
  garmentColor?: GarmentColor;
  note?: string;
  updatedAt?: string;
  updatedBy?: string;
  _rev?: string;
};

export const GARMENT_COLOR_OPTIONS: ReadonlyArray<{ value: GarmentColor; label: string }> = [
  { value: 'school', label: 'School colours' },
  { value: 'black', label: 'Black' },
];

// The editable part of the stored doc (drops _rev and the audit fields).
export function editable(t: StoredTemplates | null | undefined): Templates | null {
  if (!t) return null;
  return JSON.parse(JSON.stringify({
    version: t.version,
    enabled: t.enabled,
    garmentColor: t.garmentColor ?? 'school',
    slots: t.slots || {},
    packs: t.packs || [],
  }));
}
